import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {distributionCardSchema} from '../../../../schemas/distributionCardSchema';
import addOrUpdateCardTool from '../../../../tools/general/addOrUpdateCardTool/addOrUpdateCardTool';

export default function addOrUpdateProductCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.DISTRIBUTION,
    cardSchema: distributionCardSchema,
    description: 'Add or update DISTRIBUTION card.',
    cardSpecificInstructions:
      'Before creating, ask users to provide the number of outputs they want to add. At least 2 outputs are required. If output names are not provided, use the output "{Output} plus index + 1" as the name.',
  });
}
